<main class="login-shell" [class.login-exiting]="isNavigating">
  <div class="login-art" aria-hidden="true">
    <div class="login-area-shape"></div>
    <svg
      class="login-mountain-line"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <path
        class="login-mountain-reference"
        pathLength="1"
        d="M0 94 L100 58"
      ></path>
      <path
        class="login-mountain-primary"
        pathLength="1"
        d="M0 82 L5 77 L10 74 L15 76 L20 68 L25 61 L30 64 L35 57 L40 48 L45 51 L50 43 L55 33 L60 37 L65 30 L70 21 L75 25 L80 16 L85 6 L90 10 L95 3 L100 0"
      ></path>
    </svg>

    <div class="analytics-card analytics-card-ring login-float-one">
      <div class="metric-ring"><span></span></div>
      <div class="metric-lines"><i></i><i></i><i></i></div>
    </div>

    <div class="analytics-card analytics-card-bars login-float-two">
      <div class="bar bar-one"></div>
      <div class="bar bar-two"></div>
      <div class="bar bar-three"></div>
      <div class="bar bar-four"></div>
      <div class="bar bar-five"></div>
      <div class="bar bar-highlight"></div>
      <span class="bar-arrow"></span>
    </div>

    <div class="analytics-card analytics-card-chart login-float-three">
      <span class="currency-tile">$</span>
      <svg class="mini-trend" viewBox="0 0 132 54" aria-hidden="true">
        <polyline
          pathLength="1"
          points="0,50 24,30 46,40 72,12 95,28 132,2"
        ></polyline>
      </svg>
      <div class="metric-lines"><i></i><i></i></div>
    </div>

    <div class="analytics-card analytics-card-progress login-float-four">
      <i></i><i></i><i></i>
    </div>

    <span class="currency-tile currency-one login-float-five">$</span>
    <span class="currency-tile currency-two login-float-six">$</span>
  </div>

  <div class="login-brand">
    <img src="assets/logo-broadfactor-white-letter.png" alt="broadfactor" />
  </div>

  <form
    class="form-page"
    [formGroup]="formLogin"
    *ngIf="!showForgetPasswordPage"
  >
    <h1>Login</h1>
    <div class="form-field">
      <mat-form-field appearance="outline">
        <mat-label>E-mail</mat-label>
        <input
          #mailInput
          matInput
          aria-label="E-mail"
          formControlName="mail"
          required
          (animationstart)="onAutofill($event, 'mail', mailInput)"
        />
        <mat-error *ngIf="formLogin.get('mail')?.invalid"
          >Informe um e-mail válido</mat-error
        >
      </mat-form-field>
    </div>

    <div class="form-field password-field">
      <mat-form-field appearance="outline">
        <mat-label>Senha</mat-label>
        <input
          #passwordInput
          matInput
          aria-label="Senha"
          [type]="hide ? 'password' : 'text'"
          formControlName="password"
          required
          autocomplete="on"
          (animationstart)="onAutofill($event, 'password', passwordInput)"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hide = !hide"
          [attr.aria-label]="hide ? 'Mostrar senha' : 'Ocultar senha'"
          [attr.aria-pressed]="!hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="hasError">
      {{ errorMessage }}
    </div>

    <div class="login-form-row">
      <span class="login-password-hint">Mínimo 6 dígitos</span>
      <div class="login-forgot-password">
        <a [routerLink]="['/recuperar_senha']">Esqueceu a senha?</a>
      </div>
    </div>

    <button
      class="login-submit"
      mat-flat-button
      color="primary"
      type="button"
      *ngIf="!loading"
      [disabled]="!formLogin.valid || isNavigating"
      (click)="login()"
    >
      Entrar
    </button>
    <button
      class="login-submit"
      mat-flat-button
      color="primary"
      type="button"
      disabled
      *ngIf="loading"
    >
      Entrando
      <mat-spinner class="d-inline-block ml-2" [diameter]="20"></mat-spinner>
    </button>


  </form>

  <app-loading *ngIf="isNavigating" bgColor="#297251"></app-loading>
</main>
<app-dashboard-help
  [showAuthenticatedActions]="false"
  [sendProblemReportViaWhatsapp]="true"
></app-dashboard-help>
